import { CssClassRule } from '../../state/state-types';
import React, { useMemo, useState } from 'react';
import { useCreateInternalStateBranch } from '../../state/InternalContext';
import { TextExtractor, findFirstComponentOfType } from '../internal/TextExtractor';
/***
 * A component that adds a CSS class to an element based on a rule.
 * The rule can use data in the state to determine whether the class should be added.
 */
export function CssClassRules({ children }: { children: React.ReactNode }): React.ReactElement {
  const createInternalStateBranch = useCreateInternalStateBranch();
  const [rules, setRules] = useState<Array<CssClassRule>>([]);
  const [textExtractors, setTextExtractors] = useState<Array<React.ReactElement>>([]);

  const filteredChildren = useMemo(() => React.Children.map(children, child => {
    let ix = 0;
    if (React.isValidElement(child) && child.props.rule) {
      const conditionChild = findFirstComponentOfType(child, "arg-condition");
      const className = child.props.className;
      const id = child.props.applyToId;
      if (conditionChild && className && id) {
        setRules(prev => [...prev, { className: className, id: id, rule: "" }]);
        // Get the rule conditions from the condition child of each rule
        const textExtractor = <TextExtractor onExtractedText={
          (text) => setRules(prev => {
            const newRules = [...prev];
            newRules[ix].rule = text;
            return newRules;
          })
        }>{conditionChild}</TextExtractor>;
        setTextExtractors(prev => [...prev, textExtractor]);
        ix++;
        return null;
      }
    }
    else {
      return child;
    }
  })?.filter(Boolean), [children]);

  const BranchComponent = useMemo(() => createInternalStateBranch({
    cssClassRules: rules,
  }), [rules, createInternalStateBranch]);
  return <>
    {textExtractors}
    <BranchComponent>{filteredChildren}</BranchComponent>
  </>;
}
